export default __webpack_public_path__ + "static/media/09.d11d209f.png";